import { ActionType } from '../../../definitions/types/ActionType';
import { EntityType } from '../../../definitions/types/Entity';
import { StateType } from '../../../definitions/types/StateType';

export const updateTabReducer = (
  state: StateType,
  action: ActionType,
): StateType => {
  const payload: EntityType = action.payload as EntityType;
  const newState = { ...state };

  newState.entities = state.entities.map((entity) => {
    if (entity.type === payload.type && entity.id === payload.id) {
      return payload;
    } else {
      return entity;
    }
  });

  if (
    state.selected?.id === payload.id &&
    state.selected.type === payload.type
  ) {
    newState.selected = { ...state.selected, ...payload };
  }

  return newState;
};
